<div class="page-container" nz-row>
  <div class="notification">
    <nz-card class="ant-card-body-main" [nzBordered]="false">
      <h1 class="notification-header-text">{{'NOTIFICATIONS.HEADER' | translate}}</h1>
      <p class="sub-header-text">{{'NOTIFICATIONS.SUBHEADER' | translate}}</p>
      <br />
      <br />
      <div nz-col class="table-box" nzSpan="24">
        <nz-table
          #tamperData
          [nzLoading]="loading"
          [nzLoadingDelay]="'2000'"
          [nzShowPagination]="false"
          [nzFooter]="pagination"
          [nzData]="notifications"
          [nzTableLayout]="'auto'"
          [nzBordered]="false"
        >
          <ng-template #pagination>
            <div class="text-right">
              <nz-pagination
                [nzPageIndex]="current_page"
                [nzTotal]="total"
                [nzPageSize]="15"
                [nzItemRender]="renderItemTemplate"
                [nzShowTotal]="rangeTemplate"
              ></nz-pagination>
              <ng-template #renderItemTemplate let-type let-page="page">
                <ng-container [ngSwitch]="type">
                  <a *ngSwitchCase="'page'" (click)="next(page)">{{ page }}</a>
                  <a *ngSwitchCase="'next'" (click)="next(current_page + 1)"
                    ><strong *ngIf="nextPage">{{'GENERAL.NEXT' | translate}}</strong></a
                  >
                  <a *ngSwitchCase="'prev_5'"> << </a>
                  <a *ngSwitchCase="'next_5'">>></a>
                </ng-container>
              </ng-template>
              <ng-template #rangeTemplate let-total>
                {{ from }}-{{ to }} {{'GENERAL.OF' | translate}} {{ total }} {{'GENERAL.ITEMS' | translate}}
              </ng-template>
            </div>
          </ng-template>
          <thead>
            <tr>
              <th nzWidth="250px">{{'NOTIFICATIONS.DESCRIPTION' | translate}}</th>
              <th nzWidth="200px"></th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let data of tamperData.data; index as i" class="row-1">
              <td
                [ngStyle]="data.read ? '' : { borderLeft: '2px solid #000948' }"
              >
                <span [innerHTML]="data.notification"></span>
                <div
                  class="pt-3"
                  *ngIf="data.type === 'provision_notification'"
                  nz-row
                  [nzGutter]="[16, 10]"
                >
                  <div nz-col nzXs="24" nzSm="24" nzMd="12" nzLg="7" nzXl="6">
                    <button
                      class="gutter-row decline-btn"
                      nz-button
                      nzType="default"
                      nzSize="default"
                      (click)="
                        grantConsent(
                          'REJECTED',
                          data.provision_notification.provision_id
                        )
                      "
                      nzBlock
                    >
                      <span>{{'NOTIFICATIONS.DECLINE' | translate}}</span>
                    </button>
                  </div>
                  <div nz-col nzXs="24" nzSm="24" nzMd="12" nzLg="7" nzXl="6">
                    <button
                      class="gutter-row"
                      nz-button
                      nzType="primary"
                      nzSize="default"
                      (click)="
                        grantConsent(
                          'ACTIVE',
                          data.provision_notification.provision_id
                        )
                      "
                      nzBlock
                    >
                      <span>{{'NOTIFICATIONS.ACCEPT' | translate}}</span>
                    </button>
                  </div>
                </div>
              </td>
              <td>{{ data.created_at | date: "medium" }}</td>
            </tr>
          </tbody>
        </nz-table>
      </div>
    </nz-card>
  </div>
</div>
